var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAutomated = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / S / Automated"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9509 3.12942C14.009 2.62743 13.7252 2.14829 13.2571 1.95794C12.789 1.76759 12.2514 1.91274 11.9427 2.31283L3.60933 13.1128C3.34732 13.4524 3.30118 13.9114 3.49036 14.2963C3.67954 14.6812 4.07112 14.9251 4.50001 14.9251H10.7373L10.0491 20.8707C9.99103 21.3727 10.2748 21.8519 10.7429 22.0422C11.211 22.2326 11.7486 22.0874 12.0574 21.6873L20.3907 10.8873C20.6527 10.5478 20.6988 10.0888 20.5097 9.70386C20.3205 9.31894 19.9289 9.07508 19.5 9.07508H13.2627L13.9509 3.12942Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutomated);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/automated.f150977224662e68a2eb350fff0b8480.svg";